/* ============================================================
   Ninja Pressables — sitewide smooth "inertia" scrolling (Lenis).
   - Native scroll on touch devices (Lenis default: syncTouch off)
   - Disabled entirely under prefers-reduced-motion
   - Wrapped so it can never break the storefront
   ============================================================ */
(function () {
  'use strict';
  try {
    if (typeof Lenis === 'undefined') return;
    if (
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      return;
    }
    // Touch/mobile: native scroll (smooth-scroll here only causes sticky-header jitter)
    if (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) return;
    var lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);
    window.ncLenis = lenis; // exposed in case other scripts want to control it
  } catch (e) {
    if (window.console && console.warn) {
      console.warn('[nc-smooth] smooth scroll disabled:', e);
    }
  }
})();
